import { ComponentProps, FC } from 'react';

import { useValidatePhoneNumber } from 'utils/helpers';

import PhoneNumber from './PhoneNumber';

const PhoneNumberWithValidation: FC<ComponentProps<typeof PhoneNumber>> = (
  props,
) => {
  const { mutate: validatePhoneNumber } = useValidatePhoneNumber();

  return <PhoneNumber {...props} validatePhoneNumber={validatePhoneNumber} />;
};

export default PhoneNumberWithValidation;
